import React from 'react'
import { CircularProgress } from '@material-ui/core'
import './Loader.css'

/**
 * Lightweight viewport-centered loading overlay. Used on auth submits,
 * private-route gating, terms fetch, etc. The legacy version was a
 * 900px-tall dark navy box that took over the page; this is a fixed
 * brand-tinted backdrop that just blocks interaction while spinning.
 */
const Loader = () => {
    return (
        <div className="custom-loader-container" role="status" aria-live="polite">
            <CircularProgress
                size={48}
                thickness={4}
                style={{ color: 'var(--gp-brand)' }}
            />
        </div>
    )
}

export default Loader
